import { SVGProps } from 'react'

interface GooglePay2 extends SVGProps<SVGSVGElement> {
  color?: string
}

export const GooglePay2 = ({ color = 'black', ...props }: GooglePay2) => {
  return (
    <svg
      width="56"
      height="22"
      viewBox="0 0 56 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.1369 10.7014V17.1875H24.0811V1.17065H29.5311C30.9124 1.17065 32.0902 1.63165 33.0539 2.55364C34.039 3.47563 34.5315 4.60131 34.5315 5.93069C34.5315 7.29223 34.039 8.41792 33.0539 9.32918C32.1009 10.2405 30.9231 10.6907 29.5311 10.6907H26.1369V10.7014ZM26.1369 3.14328V8.72882H29.574C30.3877 8.72882 31.073 8.45008 31.6084 7.90332C32.1545 7.35656 32.4329 6.69187 32.4329 5.94141C32.4329 5.20168 32.1545 4.54771 31.6084 4.00095C31.073 3.43275 30.3984 3.154 29.574 3.154H26.1369V3.14328Z"
        fill={color}
      />
      <path
        d="M39.9066 5.86621C41.4271 5.86621 42.6263 6.2736 43.5043 7.08838C44.3824 7.90316 44.8214 9.01813 44.8214 10.4333V17.1874H42.8619V15.665H42.7762C41.9303 16.9194 40.7954 17.5412 39.382 17.5412C38.172 17.5412 37.1655 17.1874 36.3518 16.4691C35.538 15.7508 35.1311 14.861 35.1311 13.7889C35.1311 12.6525 35.5594 11.7519 36.416 11.0872C37.2726 10.4118 38.4183 10.0795 39.8424 10.0795C41.063 10.0795 42.0695 10.3046 42.8512 10.7549V10.2832C42.8512 9.56489 42.5728 8.96452 42.0053 8.46064C41.4378 7.95677 40.7739 7.71019 40.0137 7.71019C38.868 7.71019 37.9579 8.19262 37.294 9.16822L35.4844 8.03181C36.4802 6.5845 37.9579 5.86621 39.9066 5.86621ZM37.2512 13.821C37.2512 14.3571 37.476 14.8074 37.9365 15.1611C38.3862 15.5149 38.9216 15.6972 39.5319 15.6972C40.3992 15.6972 41.1701 15.3756 41.8447 14.7323C42.5193 14.0891 42.8619 13.3386 42.8619 12.4702C42.2194 11.9663 41.3307 11.709 40.185 11.709C39.3498 11.709 38.6539 11.9127 38.0971 12.3094C37.5296 12.7275 37.2512 13.2314 37.2512 13.821Z"
        fill={color}
      />
      <path
        d="M56.0001 6.21924L49.1473 22.0003H47.0272L49.5756 16.4791L45.0571 6.21924H47.2949L50.55 14.0883H50.5928L53.7622 6.21924H56.0001Z"
        fill={color}
      />
      <path
        d="M17.9596 9.39188C17.9596 8.72076 17.8997 8.07858 17.7883 7.46106H9.17096V10.9989L14.1339 11C13.9326 12.1771 13.2848 13.1806 12.2922 13.8496V16.1449H15.2464C16.9713 14.5464 17.9596 12.1836 17.9596 9.39188Z"
        fill="#4285F4"
      />
      <path
        d="M12.2932 13.8491C11.4709 14.4044 10.4119 14.7292 9.17309 14.7292C6.77997 14.7292 4.74984 13.1147 4.0228 10.9384H0.975464V13.3055C2.48521 16.3052 5.58823 18.3636 9.17309 18.3636C11.6508 18.3636 13.7323 17.5477 15.2474 16.1433L12.2932 13.8491Z"
        fill="#34A853"
      />
      <path
        d="M3.73583 9.18228C3.73583 8.57119 3.83755 7.98048 4.02279 7.42514V5.05798H0.975447C0.351203 6.29838 0 7.69852 0 9.18228C0 10.666 0.352274 12.0662 0.975447 13.3066L4.02279 10.9394C3.83755 10.3841 3.73583 9.79336 3.73583 9.18228Z"
        fill="#FABB05"
      />
      <path
        d="M9.17309 3.63447C10.5254 3.63447 11.7365 4.10083 12.6926 5.0121L15.3106 2.39301C13.7205 0.910319 11.6476 0.00012207 9.17309 0.00012207C5.5893 0.00012207 2.48521 2.05852 0.975464 5.0582L4.0228 7.42535C4.74984 5.24903 6.77997 3.63447 9.17309 3.63447Z"
        fill="#E94235"
      />
    </svg>
  )
}
